import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SelectInput } from 'src/app/shared/dropdown/shared/select-input.class';
import { UserDataResponse } from '../../user/shared/interfaces/login-data-response.interface';
import { LoginService } from "../../user/shared/services/login.service";
import { checkAccessAuthorization } from "../../user/shared/role.guard";
import { AuthEvent, AuthEventService } from 'src/app/user/shared/services/auth-event.service';
import { AlarmData, AlarmService, ConnectionStatus } from 'src/app/project/shared/services/camera-alarm.service';
import { Observable, Subscription } from 'rxjs';
import { CameraService } from 'src/app/project/shared/services/camera.service';

// Neues Status-Interface für bessere Typisierung
interface AlarmStatus {
  connectionStatus: ConnectionStatus;
  isAuthorized: boolean;
  isActive: boolean;
  isAcousticActive: boolean;
}

@Component({
  selector: 'avs-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
  public isMenuOpen: boolean = false;
  public isAccountSelectOpen: boolean = false;
  @Input() user?: UserDataResponse;
  public menuSelectInput: SelectInput[] = [];
  public userSelectInput: SelectInput[] = [
    { name: 'Benutzer Einstellungen', routerLink: '/user/user-data-settings' },
    { name: 'Ausloggen' }
  ];

  // Status-Anzeige Properties
  public connectionStatus: ConnectionStatus = 'disconnected';
  public currentUser: UserDataResponse | null = null;
  private subscriptions = new Subscription();

  constructor(
    private loginService: LoginService,
    private authEventService: AuthEventService,
    private alarmService: AlarmService,
    private cameraService: CameraService
  ) { }

  public ngOnInit() {
    this.setupMenu();
    this.setupStatusSubscriptions();
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

private setupStatusSubscriptions() {
    // 1) User-Daten wie gehabt
    const userSub = this.loginService.getCurrentUser()
      .subscribe(user => {
        this.currentUser = user;
      });
    this.subscriptions.add(userSub);

    // 2) Auth-Events wie gehabt -- what purpose does this have?
    const authSub = this.authEventService.events$
      .subscribe(/* (event: AuthEvent) => {
      if (event.type === 'login' || event.type === 'user-loaded') {
        this.currentUser = event.userData;
        // Connection Status wird nun über AuthEvent verwaltet
        this.updateConnectionStatusFromAuth(event.userData);
      } else if (event.type === 'logout') {
        this.currentUser = null;
        this.connectionStatus = 'disconnected';
      }
    } */);
    this.subscriptions.add(authSub);

    // 3) **AlarmService connectionStatus$ abonnieren**
    const connSub = this.alarmService.connectionStatus$
      .subscribe(status => {
        this.connectionStatus = status;
      });
    this.subscriptions.add(connSub);
  }


  // Test-Funktionalität bleibt bestehen
  testGroupId: number = 100;
  testProjectId: number = 16;

  public sendTestCameraRequest() {
    const testAlarm: AlarmData = {
      id: 148,
      guid: '9a2411af-4c57-4c8e-b56d-79b89c8ab0da',
      groupId: this.testGroupId,
      projectId: this.testProjectId,
      message: 'Test Alarm'
    };

    this.cameraService.sendAlarm(testAlarm).subscribe({
      next: (response) => {
      },
      error: (error) => {
      }
    });
  }

  // Status-Helper Methoden
  public getConnectionTitle(): string {
    const titles: Record<ConnectionStatus, string> = {
      connected: 'WebSocket verbunden',
      connecting: 'Verbinde…',
      reconnecting: 'Verbindung wird wiederhergestellt',
      disconnected: 'WebSocket getrennt',
      error: 'Verbindungsfehler'
    };
    return titles[this.connectionStatus] || 'Unbekannt';
  }

  public getConnectionStatusClass(): string {
    const statusClasses: Record<ConnectionStatus, string> = {
      connected: 'status-connected',
      connecting: 'status-connecting',
      reconnecting: 'status-reconnecting',
      disconnected: 'status-disconnected',
      error: 'status-error'
    };
    return statusClasses[this.connectionStatus] || 'status-unknown';
  }

  public isAlarmAuthorized(): boolean {
    return this.currentUser?.isAuthorizedForAlarms || false;
  }

  public areAlarmsActive(): boolean {
    return this.currentUser?.isAlarmsActivated || false;
  }

  public areAcousticAlarmsActive(): boolean {
    return this.currentUser?.isAcousticAlarmsActivated || false;
  }

  // Alarm-Status als Gesamt-Objekt
  public getAlarmStatus(): AlarmStatus {
    return {
      connectionStatus: this.connectionStatus,
      isAuthorized: this.isAlarmAuthorized(),
      isActive: this.areAlarmsActive(),
      isAcousticActive: this.areAcousticAlarmsActive()
    };
  }

  // Toggle-Funktionen (für zukünftige API-Integration)
  public toggleAlarms(): void {
    if (!this.currentUser?.isAuthorizedForAlarms) return;

    // TODO: API-Call implementieren um Alarm-Status zu ändern
  }

  public toggleAcousticAlarms(): void {
    if (!this.currentUser?.isAuthorizedForAlarms || !this.currentUser?.isAlarmsActivated) return;

    // TODO: API-Call implementieren um Acoustic Alarm-Status zu ändern
  }

  public setupMenu() {
    this.menuSelectInput.push(
      { name: 'Übersicht', routerLink: '/dashboard' },
      { name: 'Projekte', routerLink: '/project' },
      { name: 'Berichte', routerLink: '/report' }
    );

    if (!this.user) { return; }

    if (checkAccessAuthorization([1], this.user.role)) {
      this.menuSelectInput.push(
        { name: 'Geräte', routerLink: '/device' },
        { name: 'Benutzerverwaltung', routerLink: '/user' },
        { name: 'Firmenverwaltung', routerLink: '/company' }
      );
    }
  }

  public onMenuButtonClicked(): void {
    this.isMenuOpen = true;
  }

  public onMenuCloseButtonClicked(): void {
    this.isMenuOpen = false;
  }

  public onMenuListItemClicked(): void {
    this.isMenuOpen = false;
  }

  public onAccountCircleClicked(): void {
    this.isAccountSelectOpen = true;
  }

  public onUserSelectCloseButtonClicked(): void {
    this.isAccountSelectOpen = false;
  }

  public onUserSelectItemClicked(item: SelectInput): void {
    this.isAccountSelectOpen = false;
    if (item.name === 'Ausloggen') {
      this.loginService.logout();
    }
  }

   public logout(): void {
    this.loginService.logout();
  }
}
